import { take, takeUntil } from 'rxjs/operators';
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as errorUtils from 'src/app/modules/utility/global-utils';
import { I130Service } from './i130.service';
import * as RolesRouteMap from 'src/app/data/constants/roles';
import { Router } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { CreateTaskService } from '../../create-task.service';
import { DialogService } from 'primeng/dynamicdialog';
import { SendNotificationComponent } from 'send-notification';

@Component({
  selector: 'app-i130',
  templateUrl: './i130.component.html',
  styleUrls: ['./i130.component.scss'],
  providers: [DialogService]
})
export class I130Component implements OnInit, OnDestroy {
  @Input() parentFormGroup: FormGroup;
  @Input() beneficiaryList: any[];
  @Input() subTaskDetails: any;
  petitionTaskForm: FormGroup;
  serviceCenters: any[] = [];
  users: any[] = [];
  selectedPetitionPreparer: any;
  userType: string;
  primaryCompanyId: number;
  employeeDetails: any;
  dependentList: any[];
  destroy$ = new Subject();

  constructor(
    private fb: FormBuilder,
    private i130Service: I130Service,
    private router: Router,
    private createTaskService: CreateTaskService,
    public dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.petitionTaskForm = this.fb.group({
      processingType: ['regular', Validators.required],
      serviceCenterId: [null, Validators.required],
      attorneyId: [null],
      preparerAttorneyId: [null],
      immSpecialistId: [null, Validators.required],
      //filingType:['standard']
      //familyId: [null, Validators.required],
    });

    if (this.petitionTaskForm) {
      for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
        this.parentFormGroup.addControl(key, value);
      }
    }
    this.userType = sessionStorage.getItem('userTypeRole');
    this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));

    // this.createTaskService.onChangeOfSponsorSubject
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe(() => {
    //     this.getDependentList();
    //   });

    combineLatest([
      this.i130Service.getUsersOfCompany(this.primaryCompanyId),
      this.i130Service.getEmployeeDetails(
      this.primaryCompanyId, parseInt(sessionStorage.getItem('employeeId')))
    ])
      .pipe(take(1))
      .subscribe(([responseUserOfCompany, responseEmployeeDetails]: any[]) => {
        this.users = responseUserOfCompany;
        this.petitionTaskForm.patchValue({
          immSpecialistId: this.subTaskDetails && this.subTaskDetails.immSpecialistId,
         // filingType:this.subTaskDetails && this.subTaskDetails.filingType
        });
        this.onPetitionerPreparerSelected();
        this.employeeDetails = responseEmployeeDetails;
        sessionStorage.setItem("setPreparerAttorneyId", this.employeeDetails['id']);
        this.petitionTaskForm.patchValue({
          attorneyId: responseEmployeeDetails.companyId,
          preparerAttorneyId: responseEmployeeDetails.id
        });
        //this.getDependentList();
        this.onChangeProcessingType();
      });
  }

  getDependentList() {
    this.i130Service.getDependentsList(
      this.parentFormGroup.value.taskTypeCode, this.parentFormGroup.value.immClassificationCode,
      this.parentFormGroup.value.beneficiaryId)
      .pipe(take(1))
      .subscribe((responseDependentList: any) => {
        if (responseDependentList) {
          this.dependentList = responseDependentList.map(x => {
            return {
              ...x,
              displayName: `${x.firstName} ${x.lastName}`
            };
          });
        } else {
          this.dependentList = [];
        }
      });
  }

  onChangeProcessingType() {
    this.serviceCenters = [];
    this.getServiceCenter();
  }

  getServiceCenter() {
    this.i130Service.getServiceCenters(
      this.petitionTaskForm.get('processingType').value !== 'regular')
      .pipe(take(1))
      .subscribe((data: Array<any>) => {
        this.serviceCenters = data;
        if(this.subTaskDetails && this.subTaskDetails.serviceCenterId){
          this.petitionTaskForm.patchValue({serviceCenterId: this.subTaskDetails.serviceCenterId});
          this.petitionTaskForm.get('serviceCenterId').updateValueAndValidity();
        }
      });
  }

  getGlobalErrorMessages(error: string) {
    return errorUtils.errorMessages.get(error);
  }

  onPetitionerPreparerSelected() {
    const id = this.petitionTaskForm.get('immSpecialistId').value;
    this.selectedPetitionPreparer = this.users.find(ele => ele.id === id);
  }

  notifyBeneficiary() {
    const beneficiary = this.beneficiaryList.find(x => x.beneficiaryEmployeeId === this.parentFormGroup.value.beneficiaryId);
    const ref = this.dialogService.open(SendNotificationComponent, {
      width: '70%',
      contentStyle: {
        'max-height': '95vh',
        'z-index': '1000',
        'padding-bottom': '15px',
        'overflow-y': 'hidden'
      },
      closable: false,
      showHeader: false,
      closeOnEscape: false,
      modal: true,
      dismissableMask: true,
      data: {
        visaName: this.parentFormGroup.value.taskTypeCode,
        beneficiary: {
          name: beneficiary.beneficiaryEmployeeDisplayName,
          type: 'BENEFICIARY',
          employeeId: beneficiary.beneficiaryEmployeeId,
          companyId: beneficiary.companyId
        }
      }
    });
  }

  visitBeneficiaryProfile() {
    sessionStorage.setItem('listBeneficiaryId', `${this.parentFormGroup.get('beneficiaryId').value}`);
    sessionStorage.setItem('bene-profile-viewMode', 'true');
    const url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile`;
    this.router.navigate([]).then(() => {
      window.open(url, '_blank');
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.petitionTaskForm) {
      for (const [key, value] of Object.entries(this.petitionTaskForm.controls)) {
        this.parentFormGroup.removeControl(key);
      }
    }
    sessionStorage.setItem("setPreparerAttorneyId", "undefined");
  }

}
